/**
 * AiBuddy · 悬浮 AI 助手状态（全局单例）
 * ------------------------------------------------------------
 * 工作条 AI 按钮与悬浮球共用此状态：toggle 显示/隐藏，
 * 位置与轮播配置由 AiBuddy.vue 自持（localStorage）。
 */
import { ref } from 'vue'

const open = ref(false)

export function useAiBuddy() {
  function toggle() { open.value = !open.value }
  function show() { open.value = true }
  function hide() { open.value = false }
  return { open, toggle, show, hide }
}
